import { render, staticRenderFns } from "./ListPageNav.vue?vue&type=template&id=6728ba3a&scoped=true"
import script from "./ListPageNav.vue?vue&type=script&lang=js"
export * from "./ListPageNav.vue?vue&type=script&lang=js"
import style0 from "./ListPageNav.vue?vue&type=style&index=0&id=6728ba3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6728ba3a",
  null
  
)

export default component.exports